import React, { useCallback } from 'react';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import { Input } from 'ksnm-common-ui/lib/Input';
import { debounce } from 'lodash-es';
import type { Key, ReactElement } from 'react';

import { reportingTreeStore } from '@stores/reportingTreeStore';

import styles from './Search.module.scss';

interface DetailList {
  key: Key;
  title: string;
  parentKey?: Key;
}

interface ISearch {
  dataList: DetailList[];
}

export const Search = ({ dataList }: ISearch): ReactElement => {
  const { setStateTree } = reportingTreeStore;

  const onChange = useCallback(
    (value) => {
      if (!value) {
        setStateTree({ searchValue: value, autoExpandParent: false, expandedKeys: [] });
        return;
      }

      const expandedKeys = dataList
        .map((item) => {
          if (item.title.toLowerCase().indexOf(value.toLowerCase()) > -1) {
            return item.parentKey;
          }
          return null;
        })
        .filter((item, i, self) => item && self.indexOf(item) === i);

      setStateTree({ expandedKeys: expandedKeys as Key[], searchValue: value, autoExpandParent: true });
    },
    [dataList, setStateTree],
  );

  const debounceChange = debounce(onChange, 400);

  return (
    <div className={styles.wrapper}>
      <Input
        placeholder="Введите текст"
        onChange={debounceChange}
        size="small"
        allowClear={false}
        className={styles.input}
      />
      <Icon name="search" className={styles.icon} fill="#547DB1" />
    </div>
  );
};
